import { useMemo } from 'react';
import { SWRConfiguration } from 'swr';
import { ILookup, ILookupItem } from '../../api/dtos';
import useBreastMriLesionsByPatientId from '../data/useBreastMriLesionsByPatientId';

export const INVESTIGATOR_LOOKUP_OTHER = "other";

export const useBreastMriLesionLookup = (propertyName: string, patientId?: number, configuration?: SWRConfiguration) => {
    const output = useBreastMriLesionsByPatientId(patientId, configuration);

    const modifiedOutput = useMemo(() => {
        const lookupItems: ILookupItem[] = output.data ?
            output.data.map((bl) => {
                return { 
                    id: bl.id,
                    value: `Lesion Number ${bl.lesionNumber}`
                }
            }) :
            [];
    
        const lookup: ILookup = {
            propertyName: propertyName,
            items: lookupItems
        };

        return {
            ...output,
            data: lookup
        }
    }, [output, propertyName])

    return modifiedOutput;
};

export default useBreastMriLesionLookup;